import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { MenuItems } from "../../../../assets/store/navitems.store";
import { getActiveLinkIdentifier } from "../../../../core/utils/navitems.utils";
import { Theme } from "../../../themes/theme";
import PrimaryButton from "../../button/PrimaryButton";
import LanguageDropdown from "../../dropdown/LanguageDropdown";
import Logo from "../../logo/Logo";

const Wrapper = styled.header`
  width: 100%;
  height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.03);
`;

const AccentLine = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 6px;
  background-color: ${Theme.color.text.primary};
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 1800px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  box-sizing: border-box;
`;

const CenteredNav = styled.nav`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const NavItems = styled.ul`
  display: flex;
  gap: 32px;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const Item = styled.li`
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: -0.01em;
  position: relative;
  padding: 4px 0;
  transition: color 0.25s ease;

  color: ${({ $selected }) =>
    $selected ? Theme.color.text.primary : Theme.color.text.neutral};

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: ${Theme.color.text.primary};

    transform: ${({ $selected }) => ($selected ? "scaleX(1)" : "scaleX(0)")};

    transform-origin: ${({ $selected }) => ($selected ? "left" : "right")};

    transition: transform 0.3s ease;
  }

  &:hover {
    color: ${Theme.color.text.primary};
  }

  &:hover::after {
    transform: scaleX(1);
    transform-origin: left;
  }
`;

const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

function DesktopNavbar() {
  const active = getActiveLinkIdentifier(window.location.href);
  const navigate = useNavigate();
  return (
    <Wrapper>
      <AccentLine />
      <Container>
        <Logo height="60px" />

        <CenteredNav>
          <NavItems>
            {MenuItems.map((item, key) => (
              <Item
                onClick={() => {
                  navigate(item.href);
                }}
                $selected={item.identifier.includes(active)}
                key={key}
              >
                {item.name}
              </Item>
            ))}
          </NavItems>
        </CenteredNav>

        <Controls>
          <LanguageDropdown />

          <PrimaryButton onClick={() => navigate("/contact")}>
            Contact Us
          </PrimaryButton>
        </Controls>
      </Container>
    </Wrapper>
  );
}

export default DesktopNavbar;
